// Standalone module (no other imports) so both UI and state/tracking types can depend on it
// without creating an import cycle. PREORDER is client-computed and not part of the GraphQL enum.
export enum ProductBadge {
  PREORDER = 'PREORDER',
  SALE = 'SALE',
  OWN_BRAND = 'OWN_BRAND',
  GIFT_WITH_PURCHASE = 'GIFT_WITH_PURCHASE',
  MULTIPACK = 'MULTIPACK',
  EXCLUSIVE_ONLINE = 'EXCLUSIVE_ONLINE',
  NEW = 'NEW',
  EXCLUSIVE = 'EXCLUSIVE'
}
